<template>
    <select
        class="border-gray-300 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 rounded-md shadow-sm"
        :value="modelValue" @change="$emit('update:modelValue', $event.target.value)" ref="input">
        <option :value="null" :key="null" v-if="showPleaseChoose" disabled>{{ $t('Please choose') }}</option>
        <option v-for="item in items" :key="item.value" :value="item.value">{{ item.label }}</option>
    </select>
</template>

<script>
export default {
    props: ['modelValue', 'items', 'showPleaseChoose'],

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
}
</script>

